import { DRAGGABLE_WINDOWS, STATE_TO_PLAY_END_AUDIO, USER_STATE, VALIDATING_TELEPHONY } from '../../constants.js';
import { STRATEGIES_ALERTS, STRATEGIES_ERRORS } from '../../js/Strategies/Strategies_Alerts_And_Errors';
import SingletonWebSocket from '../../js/Singletons/SingletonWebSocket';
import { SingletonSharedData } from '../singletonSharedData'
import {Strategies_Preview_RecState} from '../Strategies/Strategies_Preview_RecState.js'
import { AgentButton } from 'global-components-library';
import React from 'react';

/**
 * that app.jsx
 */
export const STRATEGIES_STATES = {
    "Login": (message, that) => {
        that.setState({ isLoged: true })
        let myStorage = window.localStorage;
        myStorage.setItem('AgentTimeSpam', that.sharedData.getUserData().Login + "|" + that.agentController.getTimeStamp());
    },
    "firstCall": function (message, that, renderTag) {
        that.setState({ consulting: that.state.consulting - 1, isLogged: true });
        that.props.changeState(USER_STATE.LOGED_IN);
        that.agentController.conectSip(that.state.userLogin, renderTag);
        that.telephonyTime = message.WaitingTime;
        that.actionsValitatingTelephony();
        const integrationMessage = { client: "galatea", action: "onLogin" };
        SingletonWebSocket.send(integrationMessage);
    },
    "Ready": function (message, that) {
        if(that.props.transferReducer.currentBlindTransfer){
            that.props.resetTransfer();
            that.props.addToast(that.language.getText("CallControlGUICallTransferBlindXferSuccess"), {
                group: 'icon', 
                position: 'topRight',
                icon: '', 
                color: '', 
                btnComponent: ( <AgentButton type='tertiary'>{that.language.getText("GUIAlertMessageok")}</AgentButton>),
                timeout: 5000, 
            });
        }
        that.props.changeCampaignType(false);
        that.props.cleanData();
        that.sharedData.setIsRated(false);
        that.callId = 0;
        that.agentController.hangUp();
        that.props.changeState(USER_STATE.AGENT_READY);
        that.setState({ consulting: that.state.consulting - 1, isLogged: true, extraDataCall: {}, dataCall: {} });
        that.sharedData.setDataPreviewPro(0, that.sharedData.getDataPreviewPro().allowChangeDialMode);
        that.props.setDialingMode(0);
        if (that.sharedData.getIsPendingMessage()) {
            that.props.showUnifiedMessagesWindow(true);
            that.sharedData.setIsPendingMessage(false);
        }
        that.props.showDataTransferBySetting(false);
        setTimeout(()=> {
            that.sharedData.setIsHangedUpByAgent(STATE_TO_PLAY_END_AUDIO.HANG_UP_CLIENT);
        },2000);
    },
    "ReadyPreviewPro": function (message, that) {
        that.props.cleanData();
        that.props.changeCampaignType(false);
        that.agentController.hangUp();
        that.props.changeState(USER_STATE.READY_PREVIEW);
        that.sharedData.setDataPreviewPro(1, that.sharedData.getDataPreviewPro().allowChangeDialMode);
        that.props.setDialingMode(1);
        that.setState({ consulting: that.state.consulting - 1, isLogged: true, extraDataCall: {}, dataCall: {} });
        that.props.showDataTransferBySetting(false);
    },
    "OnValidatedTelephony": function (message, that) {
        that.sharedData.setLogged(true);
        that.props.validatingState(VALIDATING_TELEPHONY.VALID, 0);
        that.setState({ consulting: that.state.consulting - 1, isLogged: true, extraDataCall: {}, dataCall: {} });
        that.agentController.reconnectMic();
    },
    "NotReady": function (message, that) {
        that.props.removeWindow(DRAGGABLE_WINDOWS.TRANSFER_CALL)
        that.sharedData.getDataPreviewPro().dialingMode === 1 && Strategies_Preview_RecState[message.currentState](message, that)
        that.props.changeState(USER_STATE.NO_AVAILABLE);
        that.props.noAvailableData(message.frame, message.time, message.requieredPassAdmin, message.description);
    },
    "Callout": function (message, that) {
        that.callId = message.CallId;
        that.callOutId = message.CallOutId;
        that.camId = message.CamId;
        that.sharedData.setManualCallTime(message.CalloutMaxTime);
        that.props.changeState(USER_STATE.CALL_OUT);
        const data = { call_id:message.CallId,
            callout_id:message.CallOutId,
            camID:message.CamId,
            phoneNumber:message.PhoneNumber,
            calloutMaxTime:message.CalloutMaxTime
        }
        const integrationMessage = { client: "galatea", data, action: "onDialingNumber" };
        SingletonWebSocket.send(integrationMessage);
        if (that.sharedData.getIntegrationCallData() && that.sharedData.getSendDataOncallout()) {
            that.sharedData.integrationCallData.CallId=message.CallId;
            const integrationMessage2 = { client: "galatea", data: that.sharedData.integrationCallData, action: "CallFlow", subaction: "onCallRecieved" };
            SingletonWebSocket.send(integrationMessage2);
        }
        that.props.showUnifiedMessagesWindow(false);
        that.sharedData.getDataPreviewPro().dialingMode === 1 && that.props.setTempPrevRecord(message);
        that.sharedData.getDataPreviewPro().dialingMode === 1 && Strategies_Preview_RecState[message.currentState](message, that)
    },
    "Xfer": function (message, that) {
        that.sharedData.setXferTime(message.MaxXferTime);
        that.props.changeState(USER_STATE.XFER);
        that.props.showUnifiedMessagesWindow(false);
        const shared = new SingletonSharedData();
        if(message.AudioStart){
            shared.setAudioNotificationCallStart(`${window.location.protocol}//${shared.getIntegrationServer()}/GalateaAdminWS/MsgAgentAutomatic/${message.AudioStart}`);
        }else{
            shared.setAudioNotificationCallStart(null);
        }
        if(message.AudioEnd){
            shared.setAudioNotificationCallEnd(`${window.location.protocol}//${shared.getIntegrationServer()}/GalateaAdminWS/MsgAgentAutomatic/${message.AudioEnd}`);
        }else{
            shared.setAudioNotificationCallEnd(null);
        }
    },
    "logout": function (message, that) { that.props.logout(); },
    "Dialog": function (message, that) {
        that.props.setIsSendProcess(true);
        var shared = new SingletonSharedData()
        shared.problemInManualCall = false;
        const audio = shared.getAudioNotificationCallStart();
        setTimeout(() => {
            that.props.changeState(USER_STATE.DIALOG);
            shared.setAudioNotificationCallStart(null);
        }, audio ? 3000 : 0);
        shared.getDataPreviewPro().dialingMode === 1 && Strategies_Preview_RecState[message.currentState](message, that)
    },
    "Ringing": function (message, that) { 
        const shared = new SingletonSharedData()
        that.props.changeState(USER_STATE.RINGING);
        const audioToPlay = shared.getAudioNotificationCallStart();
        if(audioToPlay){
            const audio = new Audio(audioToPlay);
            audio.play();
        }
     },
    "Wrapup": function (message, that) {
        if(that.props.transferReducer.currentBlindTransfer){
            that.props.resetTransfer();
            that.props.addToast(that.language.getText("CallControlGUICallTransferBlindXferSuccess"), {
                group: 'icon', 
                position: 'topRight',
                icon: '', 
                color: '', 
                btnComponent: ( <AgentButton type='tertiary'>{that.language.getText("GUIAlertMessageok")}</AgentButton>),
                timeout: 5000, 
            });
        }
        if (message.WrapUpTime) {
            let dataCall = {
                WrapUpTime: message.WrapUpTime,
                CallId: message.CallId,
                CalKey: message.CallKey,
                CallOutId: message.CallOutId,
                CallType: message.CallType,
                Id: message.CamId ? message.CamId : that.camId,
                Phone: message.PhoneNumber ? message.PhoneNumber : that.sharedData.phoneNumber,
            }
            that.setState({ dataCall: dataCall });
        }
        that.props.changeState(USER_STATE.WRAPUP);
        if(that.sharedData.getIsHangedUpByAgent() === STATE_TO_PLAY_END_AUDIO.HANG_UP_CLIENT){
            setTimeout(() => {
                that.sharedData.setIsHangedUpByAgent(STATE_TO_PLAY_END_AUDIO.HANG_UP_AGENT);
            },3000);
        }
        that.sharedData.getDataPreviewPro().dialingMode === 1 && Strategies_Preview_RecState[message.currentState](message, that)
    },
    "ERROR": function (message, that) {
        STRATEGIES_ERRORS[message.Module](message, that);
    },
    "ALERT": function(message, that) {
        that.setState({ alert: STRATEGIES_ALERTS[message.Module](message, that) });       
        that.sharedData.getDataPreviewPro().dialingMode === 1 && Strategies_Preview_RecState[message.currentState](message, that)
    },
    "Reserved": (message, that) => {
        that.sharedData.setPhoneCallBack(message.DialingNumber);
        that.props.changeState(USER_STATE.EXCLUSIVE_CALLBACK);
    },
    "Other": function (message, that) { that.checkOtherState(); },
    "Problem": function (message, that) {
        that.props.showAlertModal({
            type: "ModalError",
            title: that.language.getText("GUIAlertMessageerror"),
            message: that.language.getText("error-9997"),
            boldMessage: that.language.getText("error-9998"),
            button: that.language.getText("GUIAlertMessagerefresh"),
            buttonFun: () => { history.go(0); }
        });
    },
    "Assisted": function (message, that) {
        that.props.changeState(USER_STATE.ASSISTED);
    }, "DialogWhatsApp": function (message, that) {
        that.props.changeState(USER_STATE.DIALOG_WHATSAPP);
    }, "WhatsApp": function (message, that) {
        that.props.changeState(USER_STATE.WHATSAPP);
    },
    "Preview": function (message, that) {
        that.props.changeState(USER_STATE.AGENT_PREVIEW);
        that.props.saveInitialTime();
    },
    "InactivePreview": function (message, that) {
        that.sharedData.setIsInactiveState(true);
        that.props.changeState(USER_STATE.INACTIVE);
      },
    "DialogEmail": (message, that) => {
        that.props.changeState(USER_STATE.DIALOG_EMAIL)
    },
    "RingingListening":(message,that) => {
        that.sharedData.getDataPreviewPro().dialingMode === 1 && Strategies_Preview_RecState[message.currentState](message, that)

    },
    "Hold":(message,that) => {
        that.sharedData.getDataPreviewPro().dialingMode === 1 && Strategies_Preview_RecState[message.currentState](message, that)
    },
    "BeforeWrapup":(message,that) => {
        that.sharedData.getDataPreviewPro().dialingMode === 1 && Strategies_Preview_RecState[message.currentState](message, that)
    },
}




// WEBPACK FOOTER //
// ./src/js/Strategies/StrategiesStates.js